import * as React from 'react';
import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import Chip from '@mui/material/Chip';

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

function getStyles(id, data, theme) {
  const fieldExists = data.findIndex((value) => value?.id === id) !== -1;

  return {
    fontWeight: fieldExists
      ? theme.typography.fontWeightMedium
      : theme.typography.fontWeightRegular,
  };
}

export default function MultipleSelect({ label, description, data, defaultData=[], onChange, loading }) {
  const theme = useTheme();
  const [selectedIds, setSelectedIds] = React.useState([]);

  React.useEffect(() => {
    if (defaultData.length > 0) {
      setSelectedIds(defaultData.map((item) => item.id));
    }
  }, [defaultData]);

  const handleChange = (event) => {
    const ids = event.target.value;
    setSelectedIds(ids);
    const selectedObjects = data.filter((item) => ids.includes(item.id));
    onChange(selectedObjects);
  };

  return (
    <FormControl className="w-100">
      <InputLabel size="small" className="w-100" id="demo-multiple-chip-label">{label}</InputLabel>
      <Select
        disabled={loading}
        className="w-100"
        labelId="demo-multiple-chip-label"
        id="demo-multiple-chip"
        multiple
        size="small"
        value={selectedIds}
        onChange={handleChange}
        input={<OutlinedInput id="select-multiple-chip" label={label} />}
        renderValue={(selected) => (
          <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5, overflowY: 'auto', maxHeight: '120px' }}>
            {selected.map((id) => {
              const item = data.find((obj) => obj.id === id);
              return <Chip key={id} label={item[description]} />;
            })}
          </Box>
        )}
        MenuProps={MenuProps}
      >
        {data.map((obj) => (
          <MenuItem
            key={obj.id}
            name={obj.id}
            value={obj.id}
            style={getStyles(obj.id, selectedIds, theme)}
          >
            {obj[description]}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
